import type { ProductTaxonomy } from '@/services/product-taxonomy';
import BaseEventGroups, { getBaseEventGroups, type BaseEventGroup } from './base-events';

/**
 * Reporting webhooks subscribe to the whole base catalog — every channel, every event — so this is
 * the base catalog under the name the webhook UI asks for.
 */
export function getWebhookEventGroups(
  options: { productTaxonomy?: ProductTaxonomy } = {},
): readonly Readonly<BaseEventGroup>[] {
  return getBaseEventGroups(options);
}

export default BaseEventGroups;
